// @ts-nocheck
import * as React from "react";
import {
    Card, CardContent, CardActions, TextField, makeStyles,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase,
    Switch, Chip

} from '@material-ui/core';

import { apolloClient as client } from "../data-provider/graphqlDataProvider";
import {getProducts,createRule,CreateBundle} from './index';
const productSeleceted = (productDiscount: Array<any>): Array<any> => {
    let result = []
    productDiscount.forEach((pd: any) => {
        if (pd.enable) {
            delete pd.enable
            delete pd.__typename
            result.push(pd)
        }

    })
    return result
}

const productType: any = {
    MENTOR: "حامی",
    DIET: "رژیم",
    BUNDLE: "باندل",
    PSYCHOLOGY_SESSION: "جلسه روان‌شناسی",
    PARTNER_DISCOUNT: "تخفیف همکار"
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

export function BundleCreate() {
    const classes = useStyles();
    const [discountType, setDiscountType] = React.useState('FINAL_PRICE');
    const [allProducts, setAllProducts] = React.useState<Array<any>>([]);
    const [productDiscount, setProductDiscount] = React.useState<Array<any>>([]);
    const [rowsLoading, setRowsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        id: "",
        title: "",
        description: "",
        currency: 'تومان',
        subtitle: "",
        subtitle2: "",
        expiryPeriod: "",
        name: "",
        isEnabled: true,
        rulesEnabled: true,
        tags: [],
        showOrder: ""
    });
    const [status, setStatus] = React.useState({ loading: false, message: '', hasError: false });

    async function getAllProducts() {
        let result = await getProducts()
        setAllProducts(result);
        let pd = result.filter(p => p.productType !== "BUNDLE").map((product: any) => ({ ...product, enable: false }))
        setProductDiscount(pd)
        setRowsLoading(true)
    }

    const handleDeleteTag = (chipToDelete) => () => {
        setValues({ ...values, tags: values.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = values.tags.some(t => t.key === newTagLabel.toUpperCase())
        if (!existTag && newTagLabel !== "")
            setValues({ ...values, tags: [...values.tags, { key: newTagLabel.toUpperCase(), label: newTagLabel }] })
    }


    const handlerEnabled = (productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, enable: !pd.enable };
            return pd;
        })
        setProductDiscount(result)
    }


    const handlerFinalPrice = (value: any, productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, price: value ? Number(value) : 0 };
            return pd;
        })
        setProductDiscount(result)
    }

    const handlerOffValue = (value: any, productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, offValue: value ? Number(value) : 0 };
            return pd;
        })
        setProductDiscount(result)
    }

    const hasPartnerProduct = (products: Array<any>) => {
        return products.some(product => product.productType === "PARTNER_DISCOUNT")
    }

    const submit = async () => {
        setStatus({ message: '', loading: true, hasError: false })
        let selectedProducts = productSeleceted(productDiscount);
        let data = {
            title: values.title,
            subtitle: values.subtitle,
            subtitle2: values.subtitle2,
            description: values.description,
            expiryPeriod: Number(values.expiryPeriod),
            name: values.name,
            currency: values.currency,
            isEnabled: values.isEnabled,
            rulesEnabled: values.rulesEnabled,
            meta: { 
                products: selectedProducts,
                 tags: values.tags.map(tag => tag.label),
                  showOrder: values.showOrder,
                  orderTrackingUrl: values.orderTrackingUrl,
                  paymentSuccessMessage: values.paymentSuccessMessage,},
            price: selectedProducts.reduce((prev, obj) => { return prev += obj.price }, 0),
            offValue: selectedProducts.reduce((prev, obj) => { return prev += obj.offValue }, 0),
            productType: "BUNDLE",
            service: "LIMOOME_SHOP",
            id: values.id
        }
        let partnerProduct = hasPartnerProduct(selectedProducts)
        if(partnerProduct)
            data = {...data, meta: {...data.meta, type: 'PARTNER_DISCOUNT'}}
        let sendData = data;
        delete sendData.rulesEnabled;
        sendToServer(sendData)
    }

    const sendToServer = async (data) => {
        CreateBundle(data).then(async(res) => {  
            if (!!res?.errors) {
                if(res.errors.length > 0 && res.errors[0].message?.includes("Unique constraint failed on the fields: (`id`)")){
                    setStatus({ loading: false, message: `خطا در ثبت! شناسه محصول تکراری است!`, hasError: true })
                }else{
                    setStatus({ loading: false, message: `خطا در ثبت! ${res.errors[0].message}`, hasError: true })
                }
            }else if(!res || !res.data){
                setStatus({ loading: false, message: 'خطای داخلی در ثبت!', hasError: true })
            } 
            if (values.rulesEnabled) {
                let productId:any;
                productId = res && res.data.createProduct.id ?  res.data.createProduct.id : null; 
                await new Promise(resolve => setTimeout(resolve, 2000));
                const ruleData = await createRule({
                    isEnabled: true,
                    step: "BEFORE_SHOW_PRODUCT",
                    ruleAddress: "http://localhost:3080/api/limoome-integrations/can-buy-diet"
                    }, productId);
                console.log("ruleData",ruleData);
                        
                if (ruleData.createRule && ruleData.createRule.id) { 
                    setStatus({ loading: false, message: 'محصول باندل با موفقیت ثبت شد', hasError: false }) 
                }else{
                    setStatus({ loading: false, message: 'محصول با موفقیت ثبت شد ولی ثبت شرط نداشتن رژیم فعال نه! لطفا به تیم فنی گزارش دهید.', hasError: true }) 
                }
            }else{
                setStatus({ loading: false, message: 'محصول باندل با موفقیت ثبت شد', hasError: false }) 
            }
            await new Promise(resolve => setTimeout(resolve, 2000));
            window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product`;

        }).catch(e => {
            console.log('error catch: ', e)
            setStatus({ loading: false, message:`خطا در ثبت! کد خطا: ${e.code || 500} `, hasError: true })
        })
    }

    React.useEffect(() => {
        getAllProducts();
    }, [])

    return (
        <Card>
            <CardContent>
                <div style={{ display: "flex", flexDirection: 'column', marginBottom: '1rem' }}>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, name: e.target.value })} value={values.name} label="کد محصول" size="medium" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, id: e.target.value })} value={values.id} label="ID" size="medium" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, title: e.target.value })} value={values.title} size="medium" label="عنوان" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, subtitle: e.target.value })} value={values.subtitle} label="زیر عنوان" size="medium" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField type="number" fullWidth onChange={(e: any) => setValues({ ...values, showOrder: Number(e.target.value) })} value={values.showOrder} label="ترتیب نمایش" size="medium" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, subtitle2: e.target.value })} value={values.subtitle2} label="زیر عنوان 2" size="medium" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>

                        <div style={{ width: '100%' }}></div>
                    </div>
                    <div style={{ marginBottom: '1rem' }}>
                        <TextField rows={3} multiline fullWidth onChange={(e: any) => setValues({ ...values, description: e.target.value })} value={values.description} size="medium" label="توضیحات" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                    <div style={{width:"50%"}}></div>
                    <div style={{ display: 'flex', justifyContent: 'center', width: '50%', alignItems: 'center' }}>
                            <Switch
                                checked={!values.rulesEnabled}
                                onChange={(e: any) => setValues({ ...values, rulesEnabled: !values.rulesEnabled })}
                                color="primary"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <p style={{ fontFamily: 'IranSans-Bold' }}>قابل خرید برای کاربران با رژیم فعال</p>
                        </div>
                      
                    </div>

                    <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center' }}>
                            <Switch
                                checked={values.isEnabled}
                                onChange={(e: any) => setValues({ ...values, isEnabled: !values.isEnabled })}
                                color="primary"
                                name="checkedA"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                            <p style={{ fontFamily: 'IranSans-Bold' }}>فعال/غیرفعال</p>
                        </div>
                        <TextField type="number" fullWidth onChange={(e: any) => setValues({ ...values, expiryPeriod: e.target.value })}
                            label="تاریخ انقضا سبد خرید" value={values.expiryPeriod} size="medium" variant="outlined"></TextField>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center' }}>
                        <div className={classes.root}>
                            {values.tags?.map((data) => {
                                return (
                                    <li key={data.key}>
                                        <Chip
                                            label={data.label}
                                            onDelete={handleDeleteTag(data)}
                                            className={classes.chip}
                                            variant="outlined"
                                        />
                                    </li>
                                );
                            })}

                        </div>
                        <TextField fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></TextField>
                    </div>
                </div>
                <div style={{ display: "flex", gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                        <TextField type="text" fullWidth onChange={(e: any) => setValues({ ...values, orderTrackingUrl: e.target.value })} value={values.orderTrackingUrl} label="پیگیری سفارش" size="medium" variant="outlined"></TextField>
                        <TextField fullWidth onChange={(e: any) => setValues({ ...values, paymentSuccessMessage: e.target.value })} value={values.paymentSuccessMessage} label="  پیغام پرداخت موفق" size="medium" variant="outlined"></TextField>
                    </div>
              
                <p style={{ fontFamily: "IranSans-Bold" }}>محصولات مربوط به باندل را از جدول زیر انتخاب کنید:</p>
                {
                    rowsLoading ?
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 700 }} align="center">محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">شناسه</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">نوع محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">فعال/غیرفعال</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ اصلی</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ تخفیف</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productDiscount.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell align="center">{productType[row.productType]}</TableCell>
                                            <TableCell align="center">
                                                <Switch
                                                    value={row.enable}
                                                    onChange={(e: any) => handlerEnabled(row.id)}
                                                    color="primary"
                                                    name="checkedA"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.price}
                                                    onChange={(e: any) => handlerFinalPrice(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ نهایی را وارد کنید"
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    value={row.offValue}
                                                    onChange={(e: any) => handlerOffValue(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder="مبلغ تخفیف را وارد کنید"
                                                />
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button style={{ color: '#fff' }} onClick={() => submit()} variant="contained" color="primary">ثبت</Button>
                    {
                        !status.loading && status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !status.loading && !status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }

                </div>
            </CardContent>
            <CardActions>

            </CardActions>
        </Card >
    )
}